/* eslint-disable @typescript-eslint/camelcase */
import { AppService } from './AbstractService';

export default class TransactionService extends AppService {
  public requestDeposit(data: FormData) {
    return this.makeRequest('POST', '/transactions/deposit', data);
  }

  public async checkBalance() {
    return this.makeRequest('GET', '/users/balance');
  }

  public requestWithdraw(data: { amount: number }) {
    return this.makeRequest('POST', '/transactions/withdraw', data);
  }

  public affiliateWithdraw(amount: number) {
    return this.makeRequest('POST', '/transactions/affiliate-withdraw', { amount });
  }

  public async refundLoss() {
    return this.makeRequest('POST', '/transactions/refund-loss');
  }

  public async getRefundLoss() {
    return this.makeRequest('GET', '/transactions/refund-loss');
  }

  public async getQr() {
    return this.makeRequest('GET', '/transactions/qr-deposit');
  }

  public async requestQr(amount: string) {
    return this.makeRequest('POST', '/transactions/qr-deposit', { amount });
  }

  public async requestBigQr(amount: string) {
    return this.makeRequest('POST', '/transactions/bigpay/qr-deposit', { amount });
  }

  public async getBigQr() {
    return this.makeRequest('GET', '/transactions/bigpay/qr-deposit');
  }

  public async requestZapQr(amount: string) {
    return this.makeRequest('POST', '/transactions/bigpay/qr-deposit', { amount });
  }

  public async getZapQr() {
    return this.makeRequest('GET', '/transactions/bigpay/qr-deposit');
  }

  public async deleteZapQr(trxId: string) {
    return this.makeRequest('DELETE', `/transactions/bigpay/qr-deposit/${trxId}`);
  }
}
